import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const AuthActionPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const mode = searchParams.get('mode');
        // Get the full query string (oobCode, apiKey, etc.) to pass along
        const params = searchParams.toString();

        if (mode === 'resetPassword') {
            // Redirect to the Password Reset Page
            navigate(`/reset-password?${params}`, { replace: true });
        } else if (mode === 'verifyEmail') {
            // Redirect to the Email Verification Page
            navigate(`/verify-email?${params}`, { replace: true });
        } else {
            // Unknown mode or recoverEmail, send to login
            console.warn('Unknown auth mode:', mode);
            navigate('/login');
        }
    }, [searchParams, navigate]);

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh' 
        }}>
            <CircularProgress />
            <Typography sx={{ mt: 2, color: 'text.secondary' }}>
                Redirecting...
            </Typography>
        </Box>
    );
};

export default AuthActionPage;